import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import ImageDocForm from '../../components/Panel/ImageDoc/ImageDocForm';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    }
  };

const ImageDocPage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
          &nbsp;>&nbsp;
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/imagedoc"}>
            Imagem Doc
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Imagens dos
          <span style={styles.tituloPagina}> Documentos</span>
        </h3>

        <ImageDocForm />

      </div>
    </Panel>

  );
};

export default ImageDocPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/ImageDocPage.js
 **/